import { post, get, postUpload } from '../index'

export default {
  // 上传图片
  uploadFiles (querys, fn) {
    return postUpload('/admin/admin/file/uploadFiles', querys, fn)
  },
  // 获取图片，视频，音频等    1=>图片  2=>音频  3=>视频
  getUploadFiles (querys) {
    return get('/admin/admin/file/listFile', querys)
  },
  // 删除图片，视频，音乐等
  delFiles (querys) {
    return post('/admin/admin/file/delFile', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/upload.js